export default "17c25475c0369f7f.ttf"